import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import PopupModelWrapper from "../wrappers/PopupModelWrapper";
import { Stack, Typography } from "@mui/material";
import TopUpChipButton from "./TopUpChipButton";
import PopupButton from "../common/PopupButton";
import useAuth from "../../hooks/useAuth";
import useData from "../../hooks/useApi";
import useMessage from "../../hooks/useMessage";
import {
    dataErrorCallback,
    dataPopupClosed,
    dataPopupWebhookReceived,
    setupFastspring,
} from "../../utils/fastspringUtils";

export enum TopUpOptions {
    TWENTY = 20,
    FIFTY = 50,
    HUNDRED = 100,
    TWO_HUNDRED = 200,
    FIVE_HUNDRED = 500,
}

export const topUpValues = [
    TopUpOptions.TWENTY,
    TopUpOptions.FIFTY,
    TopUpOptions.HUNDRED,
    TopUpOptions.TWO_HUNDRED,
    TopUpOptions.FIVE_HUNDRED,
];

type WalletTopUp = {
    open: boolean;
    message: string;
    selectedAmount: TopUpOptions;
    setOpen: Dispatch<SetStateAction<boolean>>;
};

const WalletTopUpModel = (props: WalletTopUp) => {
    const { open, message, selectedAmount, setOpen } = props;

    const [activeChipButton, setActiveChipButton] =
        useState<TopUpOptions>(selectedAmount);

    const setAlertFunc = () => {
        handleClose();
        buyProduct();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const auth = useAuth();
    const api = useData();
    const { showSuccess } = useMessage();
    // @ts-expect-error expecting an error
    const fastspring = window.fastspring;

    useEffect(() => {
        // @ts-expect-error not an error
        window.dataErrorCallback = (code: number, message: string) =>
            dataErrorCallback(code, message, auth);
        // @ts-expect-error not an error
        window.dataPopupWebhookReceived = (details: any) =>
            dataPopupWebhookReceived(details, activeChipButton, auth, api);
        // @ts-expect-error not an error
        window.dataPopupClosed = (details: any) =>
            dataPopupClosed(details, showSuccess);
    }, [fastspring, activeChipButton]);

    const buyProduct = () => {
        if (fastspring?.builder) {
            setupFastspring(
                fastspring,
                activeChipButton,
                auth.user?.email || "",
                auth.user?.username || "",
            );
        }
    };

    return (
        <PopupModelWrapper
            open={open}
            handleClose={handleClose}
            title="Top-up Confirmation"
            width={{ md: "600px", sm: "300px", xs: "300px" }}
        >
            <Stack>
                <Typography
                    sx={{
                        fontSize: { xs: 12, sm: 14 },
                        fontWeight: 500,
                        color: "#3A3541CC",
                        mt: 3,
                    }}
                >
                    {message}
                </Typography>
                <Stack direction="row" justifyContent="space-evenly" my={2}>
                    {topUpValues.map((value) => (
                        <TopUpChipButton
                            key={value}
                            activeValue={activeChipButton}
                            setActiveChipButton={setActiveChipButton}
                        >
                            {value as TopUpOptions}
                        </TopUpChipButton>
                    ))}
                </Stack>
                <Stack direction="row" justifyContent="flex-end">
                    <PopupButton
                        triggerFunction={handleClose}
                        type="cancel"
                        id="domains-input-popup-cancel"
                    >
                        Cancel
                    </PopupButton>
                    <PopupButton
                        triggerFunction={setAlertFunc}
                        type="proceed"
                        id="domains-input-popup-add"
                    >
                        Top-up
                    </PopupButton>
                </Stack>
            </Stack>
        </PopupModelWrapper>
    );
};

export default WalletTopUpModel;
